<template>
  <div
    class="onboarding-user-docs-item">
    <div class="onboarding-user-docs-item__title">
      <div
        v-loading="loading">
        <i class="icon-onboarding-document"/>
      </div>
      {{ $t(`entity.Document.${documentFile.type}`) }} {{ documentFile?.side ? $t(`entity.DocumentSide.${documentFile.side}`) : '' }}
      <ElTooltip
        v-if="isReviewedDoc"
        :content="$t('pages.onboarding.admin_page.reviewed_tooltip')"
        placement="top"
        popper-class="statement-tooltip"
        effect="dark">
        <SvgIcon
          type="core"
          size="16"
          name="icon-success"/>
      </ElTooltip>
    </div>
    <div class="onboarding-user-docs-item__btns">
      <i
        v-if="!hideUpload"
        class="icon-pencil-edit"
        @click="editDocument"/>
      <i
        class="icon-download-document"
        @click="downloadDocument(documentFile.type)"/>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';

import SvgIcon from '@/_redesign/shared/ui/SvgIcon/SvgIcon.vue';
import {
  DocumentSide,
  OnboardingDocument,
  ReviewedDocument,
  UnionDocument,
} from '@/types/interfaces/Document.interface';

type IDocumentType = UnionDocument;

const {
  documentFile,
  downloadFile,
  hideUpload,
  editFile,
  uploadingType,
  isExternalLoading,
} = defineProps<{
  documentFile: OnboardingDocument | ReviewedDocument;
  downloadFile?: Function;
  hideUpload: boolean;
  editFile:((documentType: IDocumentType, documentSide: DocumentSide) => Promise<void>);
  uploadingType: IDocumentType | null;
  isExternalLoading?: boolean;
  isReviewedDoc?: boolean;
}>();

const emit = defineEmits<{
  download: [document: ReviewedDocument | OnboardingDocument];
}>();

const isLoading = ref(false);
const loading = computed(() => isLoading.value || uploadingType === documentFile.type || isExternalLoading);

async function downloadDocument(type: IDocumentType) {
  isLoading.value = true;
  emit('download', documentFile);
  if (downloadFile) await downloadFile(type, documentFile.side);
  isLoading.value = false;
}

async function editDocument() {
  isLoading.value = true;
  await editFile(documentFile.type, documentFile.side);
  isLoading.value = false;
}
</script>

<style lang="scss">
.el-loading-spinner .circular {
  @apply w-16;
}
</style>
